/* istanbul ignore file */
import { CommunitiesEndpoints } from 'src/client/constants';
import { PropsCommunity } from 'src/pages/CommunityDetails/Posts/types';
import api from '../services/api';
import apiSparkle from '../services/apiSparkle';
import { MyCommunity } from './types';

export const getCommunities = async (slug: string, nextPageToken: string, rows: number) => {
  const nextPage = nextPageToken ? `&nextPageToken=${nextPageToken}` : '';
  const url = `${CommunitiesEndpoints.getAllCommunities()}?slug=${slug}&rows=${rows}${nextPage}`;
  const res = await api.get(url);
  return res.data;
};

export const getCommunity = async (communityId: number) => {
  const url = CommunitiesEndpoints.getCommunity(communityId);
  const res = await api.get<PropsCommunity>(url);

  return res.data;
};

export const getCommunityBySlug = async (
  communitySlug?: string
): Promise<PropsCommunity | undefined> => {
  if (!communitySlug) return;

  const url = CommunitiesEndpoints.getCommunityBySlug(communitySlug);
  const res = await apiSparkle.get<PropsCommunity>(url);

  return res.data;
};

export const putCoverImage = async (
  id: number,
  payload: PropsCommunity
): Promise<PropsCommunity> => {
  const url = CommunitiesEndpoints.putCoverImage(id);
  const res = await api.put(url, payload);

  return res.data;
};

export const verifyLinksCommunity = async (slug: string, courseId: number) => {
  const url = `/rest/v1/membership/${slug}/collectionCourses?courseIds=${courseId}`;
  const res = await apiSparkle.get(url);
  return res.data;
};

export const banMemberCommunity = async (collectionId: number, userId: number) => {
  const url = CommunitiesEndpoints.putBanMember(collectionId);
  const res = await apiSparkle.put(url, `userId=${userId}`, {
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'data-urlencode': `userId=${userId}`
    }
  });

  return res.data;
};

export const getCommunityAssociatedCourseStatus = async (communityId: number): Promise<boolean> => {
  const url = CommunitiesEndpoints.getCommunityAssociatedCourseStatus(communityId);
  const res = await api.get(url);
  return res.data;
};

export const getCommunityAssociatedCourseStatusPublic = async (
  communityId: number
): Promise<boolean> => {
  const url = CommunitiesEndpoints.getCommunityAssociatedCourseStatusPublic(communityId);
  const res = await api.get(url);
  return res.data;
};

export const getMyCommunities = async (ucode?: string, rows?: number): Promise<MyCommunity[]> => {
  const url = CommunitiesEndpoints.getMyCommunities(ucode, rows);
  const res = await api.get(url);
  return res?.data?.data;
};
